import { sessionPrefix } from "./helpers";

export const projectReportsPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/project-reports`;
export const showProjectReportPath = (session: LightSessionInterface, report: ProjectReportListItem) =>
  `${sessionPrefix(session)}/project-reports/${report.id}`;
export const editProjectReportPath = (session: LightSessionInterface, report: ProjectReportListItem) =>
  `${sessionPrefix(session)}/project-reports/${report.id}/edit`;
export const newProjectReportPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/project-reports/new`;
